import HomeBody from '../features/home/presentation/home-body'
import { useEffect } from 'react'
import ReactGA from 'react-ga4'


export default function HomeView() {
  useEffect(()=> {
    ReactGA.initialize('G-BQ4B9VCM9L')
    ReactGA.send({
      hitType: 'pageview',
      page: '/home',
      title: 'Home View'
    } 
    )
  }, [])
  return (
    <>
			<HomeBody/>
    </>
  )
}